import { render } from "./QuickAdd.vue?vue&type=template&id=6aad15d9&scoped=true"
import script from "./QuickAdd.vue?vue&type=script&lang=js"
export * from "./QuickAdd.vue?vue&type=script&lang=js"

import "./QuickAdd.vue?vue&type=style&index=0&id=6aad15d9&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aad15d9"]])

export default __exports__